import { forwardRef } from "react";
import * as SelectPrimitive from "@radix-ui/react-select";

import type {
  TSelectLabelElement,
  TSelectLabelProps,
} from "@/ui/components/form/Select/Select.config";
import { TextControl } from "@/ui/components/typography/TextControl";
import { cn } from "@/ui/lib/utils";

export const SelectLabel = forwardRef<TSelectLabelElement, TSelectLabelProps>(
  (
    {
      children,
      className,
      ...props
    },
    ref,
  ) => (
    <SelectPrimitive.Label
      data-component="SelectLabel"
      ref={ref}
      className={cn("px-2 py-1.5", className)}
      {...props}
    >
      <TextControl tag="span" size={2} isResponsive={false}>
        { children }
      </TextControl>
    </SelectPrimitive.Label>
  ),
);

SelectLabel.displayName = SelectPrimitive.Label.displayName;
